import {
  type GetWorkerRequirementRequest,
  type GetWorkerRequirementsResponse,
  getWorkerRequirementsResponseSchema,
} from "@clipboard-health/contract-worker-app-bff";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { type AxiosError } from "axios";
import { minutesToMilliseconds } from "date-fns";
import { isEmpty } from "lodash";

import { mergeWorkerRequirementWithIncludedResources } from "./mergeWorkerRequirementWithIncludedResources";
import { type WorkerRequirement } from "./types";

export const GET_WORKER_REQUIREMENTS_PATH = "/worker-requirements";
export const GET_WORKER_REQUIREMENTS_URL = `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}${GET_WORKER_REQUIREMENTS_PATH}`;

export const workerRequirementsBaseQueryKey = [GET_WORKER_REQUIREMENTS_URL];

export function useGetWorkerRequirements(
  queryParams: GetWorkerRequirementRequest,
  options: UseGetQueryOptions<GetWorkerRequirementsResponse, AxiosError, WorkerRequirement[]> = {}
) {
  // Need to check for filter in queryParams for type safety
  const hasQualifications = "filter" in queryParams && !isEmpty(queryParams.filter.qualifications);

  return useGetQuery<
    GetWorkerRequirementRequest,
    GetWorkerRequirementsResponse,
    WorkerRequirement[]
  >({
    url: GET_WORKER_REQUIREMENTS_URL,
    queryParams,
    responseSchema: getWorkerRequirementsResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_WORKER_REQUIREMENTS_FAILURE,
    },
    staleTime: options.staleTime ?? minutesToMilliseconds(5),
    select: mergeWorkerRequirementWithIncludedResources,
    ...options,
    enabled: hasQualifications && (options.enabled ?? true),
  });
}
